export default __webpack_public_path__ + "static/media/OldNumberCode.abf63139.png";